import { createQuote, getQuotes, acceptQuote, rejectQuote } from '../services/api';
import { sanitizeForm } from '../utils/security';

// ── Supplier sends a quote ──
export const handleCreateQuote = async (rawForm) => {
  const form = sanitizeForm(rawForm, {
    notes: 500,
  });

  const requestId = form.request || form.requestId;
  if (!requestId)  return { error: 'Talep ID zorunludur.' };
  if (!form.condition) return { error: 'Parça durumu seçilmelidir.' };

  const price = parseFloat(form.price);
  if (isNaN(price) || price <= 0)   return { error: 'Geçerli bir fiyat girin.' };
  if (price > 1_000_000)            return { error: 'Fiyat 1.000.000 ₺ üzerinde olamaz.' };
  if (!form.leadTime && !form.lead_time) return { error: 'Temin süresi seçilmelidir.' };
  if (form.notes?.length > 500)     return { error: 'Notlar en fazla 500 karakter olabilir.' };

  const fields = {
    request:      requestId,
    condition:    form.condition,
    price:        price,
    vat_included: form.vatIncluded ?? true,
    lead_time:    form.leadTime || form.lead_time,
    notes:        form.notes || '',
    iban:         (form.iban || '').replace(/\s/g, '').toUpperCase(),
  };

  // Attach photos (optional) → send as multipart FormData.
  const images = Array.isArray(rawForm.images) ? rawForm.images : [];
  let payload = fields;
  if (images.length) {
    payload = new FormData();
    Object.entries(fields).forEach(([k, v]) => payload.append(k, v));
    images.slice(0, 5).forEach(file => payload.append('images', file));
  }

  try {
    const res = await createQuote(payload);
    return { success: true, data: res.data };
  } catch (err) {
    const errors = err.response?.data?.errors;
    if (errors) {
      const first = Object.values(errors)[0];
      return { error: Array.isArray(first) ? first[0] : first };
    }
    const msg = err.response?.data?.message;
    return { error: msg || 'Teklif gönderilemedi.' };
  }
};

// ── Get all quotes (customer sees own, supplier sees own) ──
export const handleGetQuotes = async (params = {}) => {
  try {
    const res = await getQuotes(params);
    return { success: true, data: res.data };
  } catch {
    return { error: 'Teklifler yüklenemedi.' };
  }
};

// ── Customer accepts a quote ──
export const handleAcceptQuote = async (quoteId) => {
  try {
    const res = await acceptQuote(quoteId);
    return { success: true, data: res.data };
  } catch (err) {
    return { error: err.response?.data?.message || 'Teklif kabul edilemedi.' };
  }
};

// ── Customer rejects a quote ──
export const handleRejectQuote = async (quoteId) => {
  try {
    const res = await rejectQuote(quoteId);
    return { success: true, data: res.data };
  } catch (err) {
    return { error: err.response?.data?.message || 'Teklif reddedilemedi.' };
  }
};